export const styles = {
  container: {
    maxWidth: "480px",
    margin: "0 auto",
    background: "#F8FAFC",
    minHeight: "100vh",
    position: "relative",
    paddingBottom: "80px",
    fontFamily: "'Inter', sans-serif",
  },
  headerHero: {
    background: "linear-gradient(180deg, #1e293b 0%, #334155 100%)",
    padding: "70px 20px 30px 20px",
    borderRadius: "0 0 24px 24px",
    color: "white",
    marginBottom: "0px",
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  },
  navbar: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 20px",
    zIndex: 100,
  },
  brandName: {
    color: "white",
    fontSize: "13px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    opacity: 0.9,
  },
  inputField: {
    width: "100%",
    padding: "10px 12px",
    marginBottom: "10px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    fontSize: "13px",
    boxSizing: "border-box",
    background: "white",
    outline: "none",
    transition: "border 0.2s",
  },
  primaryBtn: {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "13px",
    background: "#0f172a",
    color: "white",
  },
  loginBtnSmall: {
    padding: "5px 12px",
    borderRadius: "20px",
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.1)",
    color: "white",
    fontSize: "11px",
    fontWeight: "600",
    cursor: "pointer",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    transition: "background 0.2s",
  },
  floatingCard: {
    background: "white",
    borderRadius: "20px",
    boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
    padding: "20px",
    position: "relative",
    zIndex: 10,
    marginBottom: "20px",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "12px",
  },
  gridItem: {
    background: "white",
    padding: "15px 10px",
    borderRadius: "16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.02)",
    border: "1px solid #F1F5F9",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    textDecoration: "none",
    color: "#334155",
  },
  gridIconBox: {
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "8px",
  },
  listCard: {
    background: "white",
    borderRadius: "20px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.03)",
    border: "1px solid #F1F5F9",
    overflow: "hidden",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px",
    textDecoration: "none",
    color: "#334155",
    borderBottom: "1px solid #F1F5F9",
    fontSize: "14px",
    fontWeight: "500",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(15, 23, 42, 0.6)",
    backdropFilter: "blur(4px)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  modalCard: {
    background: "white",
    borderRadius: "24px",
    padding: "30px",
    width: "100%",
    maxWidth: "300px",
    textAlign: "center",
    boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
    position: "relative",
  },
  compactCard: {
    background: "white",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    padding: "20px",
    border: "1px solid #f1f5f9",
  },
  loginOverlay: {
    padding: "0 20px",
    marginTop: "-20px",
    position: "relative",
    zIndex: 20,
  },
  filterContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: 8,
    marginBottom: 10,
  },
  filterSelect: {
    padding: "8px 5px",
    borderRadius: "8px",
    border: "1px solid #E2E8F0",
    fontSize: "11px",
    outline: "none",
    background: "white",
    color: "#475569",
    width: "100%",
    cursor: "pointer",
  },
};
